import dataType from '../dataType';

const FirdsFcaInstrument = {
    name: 'FirdsFcaInstrument',
    type: dataType.string
};

export default FirdsFcaInstrument;
